/*
  Animated placeholder for the header search input.

  Types each popular search term one character at a time, holds it, deletes it
  character by character, then moves on to the next term. Focusing the input
  stops the animation and swaps in a plain prompt.

  Usage (see sections/header.liquid):
    <input data-search-terms="Chair, Bench" data-search-prompt="What are you looking for?" ...>
*/
(function () {
  var TYPE_SPEED = 90;
  var DELETE_SPEED = 45;
  var HOLD_TIME = 1600;
  var GAP_TIME = 400;
  var BLINK_TIME = 530;
  var CARET = '|';
  var BLANK = '\u00A0'; // non-breaking space, so the caret can blink off

  function parseTerms(value) {
    return (value || '')
      .split(',')
      .map(function (term) {
        return term.trim();
      })
      .filter(Boolean);
  }

  function init(input) {
    var prompt = input.dataset.searchPrompt;
    if (!prompt) return;

    var fallback = input.placeholder;
    var words = parseTerms(input.dataset.searchTerms);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // No terms configured, or motion is reduced: keep whatever placeholder the
    // theme rendered and only swap in the prompt while the input is focused.
    if (!words.length || reduced) {
      input.addEventListener('focus', function () {
        input.placeholder = prompt;
      });
      input.addEventListener('blur', function () {
        if (!input.value) input.placeholder = fallback;
      });
      return;
    }

    var word = 0;
    var char = 0;
    var deleting = false;
    var caretOn = true;
    var typeTimer = null;
    var blinkTimer = null;
    var running = false;

    function paint() {
      input.placeholder = words[word].slice(0, char) + (caretOn ? CARET : BLANK);
    }

    function schedule(delay) {
      clearTimeout(typeTimer);
      typeTimer = setTimeout(step, delay);
    }

    function step() {
      if (deleting) {
        char -= 1;
        paint();
        if (char <= 0) {
          deleting = false;
          word = (word + 1) % words.length;
          schedule(GAP_TIME);
        } else {
          schedule(DELETE_SPEED);
        }
        return;
      }

      char += 1;
      paint();
      if (char >= words[word].length) {
        deleting = true;
        schedule(HOLD_TIME);
      } else {
        schedule(TYPE_SPEED);
      }
    }

    function blink() {
      caretOn = !caretOn;
      paint();
    }

    function start() {
      if (running) return;
      running = true;
      blinkTimer = setInterval(blink, BLINK_TIME);
      step();
    }

    function stop() {
      running = false;
      clearTimeout(typeTimer);
      clearInterval(blinkTimer);
      typeTimer = null;
      blinkTimer = null;
    }

    input.addEventListener('focus', function () {
      stop();
      input.placeholder = prompt;
    });

    input.addEventListener('blur', function () {
      if (input.value) return;
      start();
    });

    input.addEventListener('input', function () {
      if (input.value) {
        stop();
      } else if (document.activeElement !== input) {
        start();
      }
    });

    paint();
    start();
  }

  function boot() {
    document.querySelectorAll('input[data-search-prompt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
